<template>
  <TooltipProvider :delay-duration="300">
    <div
      class="
        absolute -top-3 right-2 flex items-center gap-0.5 rounded-md border bg-background p-0.5
        opacity-0 shadow-sm transition-opacity
        group-hover/msg:opacity-100
      "
    >
      <!-- Copy -->
      <Tooltip>
        <TooltipTrigger as-child>
          <Button
            variant="ghost"
            size="icon"
            class="size-6"
            @click="$emit('copy')"
          >
            <Copy class="size-3" />
          </Button>
        </TooltipTrigger>
        <TooltipContent side="top">
          {{ t('ai.copyMessage') }}
        </TooltipContent>
      </Tooltip>

      <!-- Regenerate (assistant only) -->
      <Tooltip v-if="role === 'assistant'">
        <TooltipTrigger as-child>
          <Button
            variant="ghost"
            size="icon"
            class="size-6"
            @click="$emit('regenerate')"
          >
            <RotateCcw class="size-3" />
          </Button>
        </TooltipTrigger>
        <TooltipContent side="top">
          {{ t('ai.regenerate') }}
        </TooltipContent>
      </Tooltip>

      <!-- Edit & Resend (user only) -->
      <Tooltip v-if="role === 'user'">
        <TooltipTrigger as-child>
          <Button
            variant="ghost"
            size="icon"
            class="size-6"
            @click="$emit('editResend')"
          >
            <Pencil class="size-3" />
          </Button>
        </TooltipTrigger>
        <TooltipContent side="top">
          {{ t('ai.editAndResend') }}
        </TooltipContent>
      </Tooltip>
    </div>
  </TooltipProvider>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import { Copy, Pencil, RotateCcw } from 'lucide-vue-next'

import { Button } from '@/components/ui/button'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip'

defineProps<{
  role: 'user' | 'assistant'
}>()

defineEmits<{
  copy: []
  regenerate: []
  editResend: []
}>()

const { t } = useI18n()
</script>
